export enum StepEnum {
    General = 0,
    AlarmNotifications = 1,
    Membership = 2,
    Security = 3,
    PageVisibility = 4
}
